const config = {
    //servBackEnd : "http://localhost:3001"
    servBackEnd : "https://onrlbp692j.execute-api.us-east-1.amazonaws.com/pdn"
};

export default config;